import { useEffect } from 'react';

const BASE = 'Lens';

/**
 * Пишет заголовок вкладки браузера. Части идут от частного к общему и
 * склеиваются через « · », в конце всегда «— Lens»: во вкладке видно, что за
 * пространство открыто, даже когда браузер обрезал хвост.
 *
 * Пустые части пропускаются, при уходе со страницы заголовок возвращается
 * к «Lens».
 */
export function useDocumentTitle(...parts: Array<string | null | undefined>): void {
  const head = parts.filter((p): p is string => Boolean(p && p.trim())).join(' · ');
  const title = head ? `${head} — ${BASE}` : BASE;
  useEffect(() => {
    document.title = title;
    return () => {
      document.title = BASE;
    };
  }, [title]);
}
